import styled from 'styled-components';

export const Progress = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 30;
`;
